import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const setupPasswordRoute = () => {
  return {
    name: AUTH_ROUTE_NAME.SETUP_PASSWORD,
    path: "setup-password",
    component: () => import("@/pages/auth/setup-password.vue")
  };
};
